import { render, staticRenderFns } from "./MerchantDiscounts.vue?vue&type=template&id=336a909c"
import script from "./MerchantDiscounts.vue?vue&type=script&lang=js"
export * from "./MerchantDiscounts.vue?vue&type=script&lang=js"
import style0 from "./MerchantDiscounts.vue?vue&type=style&index=0&id=336a909c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports